<template>
  <div class="magnetic-braking-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F_eddy ∝ -v · B²$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Tube (Copper/Aluminum) -->
          <rect x="180" y="20" width="40" height="200" fill="rgba(184, 134, 11, 0.4)" stroke="#b8860b" />
          <text x="230" y="40" fill="#b8860b" font-size="8">金属管 (非磁性)</text>

          <!-- The Falling Magnet -->
          <g :transform="`translate(185, ${posY % 200 + 10})`">
             <rect x="0" y="0" width="30" height="40" fill="#ff4757" />
             <rect x="0" y="40" width="30" height="40" fill="#00d2ff" />
             <text x="10" y="25" fill="#fff" font-size="10">N</text>
             <text x="10" y="65" fill="#fff" font-size="10">S</text>
             
             <!-- Eddy Current rings in the tube -->
             <ellipse v-if="isSlow" cx="15" cy="0" rx="30" ry="10" fill="none" stroke="#ffd700" stroke-width="1" opacity="0.6" />
             <ellipse v-if="isSlow" cx="15" cy="80" rx="30" ry="10" fill="none" stroke="#ffd700" stroke-width="1" opacity="0.6" />
          </g>

          <!-- The Reference Weight (Normal fall) -->
          <g :transform="`translate(100, ${posYNormal % 200 + 10})`">
             <rect x="0" y="0" width="20" height="40" fill="#555" />
             <text x="-15" y="-5" fill="#888" font-size="8">普通物体</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>下落状态: {{ isSlow ? '处于磁致阻控中 (缓慢)' : '自由下落' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <el-button type="primary" size="mini" @click="reset">同步释放</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当强磁铁穿过导电金属管（如铜管）时，变化的磁场在管壁内产生循环的**涡电流**。根据楞次定律，这些电流产生的磁场会反抗原磁体的运动，从而产生强大的阻力。尽管重力依然存在，但磁铁会像在粘稠液体中一样极其缓慢地降落。这就是高铁和工业电梯中**磁力刹车**的原理。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MagneticBrakingViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      posY: 0,
      posYNormal: 0,
      isSlow: true,
      timer: null
    }
  },
  methods: {
    update() {
       // Normal fall: a = g
       this.posYNormal += 5; 
       // Magnetic braking: reaching terminal velocity very quickly due to damping
       this.posY += 0.8; 
       this.timer = requestAnimationFrame(this.update);
    },
    reset() {
       this.posY = 0;
       this.posYNormal = 0;
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.magnetic-braking-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
